<ifc-base-dialog title="Assign business advisor"
                 [actions]="actions"
                 (actionClicked)="onActionClicked($event)">
  <ng-template #content>
    <form [formGroup]="form"
          class="form">
      <ifb-business-advisor-input [fc]="form.get('fullName')"></ifb-business-advisor-input>
    </form>
  </ng-template>
</ifc-base-dialog>
